import { configureStore } from "@reduxjs/toolkit";
import reportReducer from "./slices/dashboard";

const saveState = (state) => {
  try {
    // Strip out HTML content to keep localStorage size manageable
    // Support up to 500 records to match/exceed legacy behavior
    const recentReports = state.report.reports.slice(0, 500).map(report => {
      const savedReport = {
        vin: report.vin,
        year: report.year,
        make: report.make,
        model: report.model,
        body: report.body,
        reportStatus: report.reportStatus,
        reportStatusCode: report.reportStatusCode,
        reportStatusName: report.reportStatusName,
        vindecodeResultCode: report.vindecodeResultCode,
        score: report.score,
        scoreLow: report.scoreLow,
        scoreHigh: report.scoreHigh,
        assured: report.assured,
        ownerCount: report.ownerCount,
        accidentCount: report.accidentCount,
        eventCount: report.eventCount,
        lastOdometer: report.lastOdometer,
        bbp: report.bbp,
        lang: report.lang,
        reportType: report.reportType,
        _sourceType: report._sourceType,
      };
      
      // Only save report type markers if they exist (don't save HTML to save space)
      if (report.FULLREPORT) {
        savedReport.FULLREPORT = { html: '' };
      }
      if (report.SUMMARYREPORT) {
        savedReport.SUMMARYREPORT = { html: '' };
      }
      if (report.ACCIDENTREPORT) {
        savedReport.ACCIDENTREPORT = { html: '' };
      }
      
      return savedReport;
    });
    
    const stateToSave = {
      ...state,
      report: {
        ...state.report,
        reports: recentReports
      }
    };
    
    const serializedState = JSON.stringify(stateToSave);
    localStorage.setItem("currentReports", serializedState);
  } catch (e) {
    console.error("Could not save state", e);
    // If still failing, clear localStorage and continue
    try {
      localStorage.removeItem("currentReports");
    } catch (clearError) {
      console.error("Could not clear localStorage", clearError);
    }
  }
};

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("currentReports");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Could not load state", e);
    return undefined;
  }
};

const persistedState = loadState();

const store = configureStore({
  reducer: {
    report: reportReducer,
  },
  preloadedState: persistedState,
});

store.subscribe(() => {
  saveState(store.getState());
});



export default store;
